<template>
  <Form ref="companyInfo" :model="editParams" :rules="editRules" class="edit-company" :label-width="160" v-loading="loading" >
    <template>
      <FormItem label="企业编码">
        <span class="edit-company-val">{{editParams.custNo}}</span>
      </FormItem>
      <FormItem label="企业名称">
        <span class="edit-company-val">{{editParams.companyName}}</span>
      </FormItem>
      <FormItem label="企业类型">
        <span class="edit-company-val">{{editParams.companyType}}</span>
      </FormItem>
      <FormItem label="企业域">
        <span class="edit-company-val">{{editParams.companyDomain}}</span>
      </FormItem>
      <FormItem label="管理员账号">
        <span class="edit-company-val">{{editParams.sellerName}}</span>
      </FormItem>
      <FormItem label="密码" prop="password" class="ivu-form-item-required data-item">
        <div class="resetBtns" v-show="!editPassword">
          <span class="edit-company-val">******<a @click="resetPassword" class="reset-password" href="javascript:;">重置密码</a></span>
        </div>
        <div v-show="editPassword">
          <Input type="password" t v-model="editParams.password" placeholder="请输入密码" />
          <span class="tip-bottom">6-20位字符，可由英文、数字及标点符号组成</span>
        </div>
      </FormItem>
      <FormItem  label="密码确认" prop="resetPassword" v-show="editPassword" class="ivu-form-item-required data-item">
        <Input type="password" v-model="editParams.resetPassword" placeholder="请确认密码" />
      </FormItem>
      <FormItem label="类型" prop="type">
        <RadioGroup v-model="editParams.type">
          <Radio :label="1">试用</Radio>
          <Radio :label="2">正式</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem  class='is-test' label="是否测试账号" prop="is_test">
        <RadioGroup v-model="editParams.is_test">
          <Radio label="0">否</Radio>
          <Radio label="1">是</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem  class='' label="会员类型" prop="hyLevel">
        <div class="vip-type" v-if="vipType.length !== 0">
          <div class="vip-type__item"
            v-for="item in vipType"
            :key="item.yjh_hy_level">
            <div class="vip-type__title">{{item.vipText}}</div>
            <div class="vip-type__time">{{item.vipTime}}</div>
          </div>
        </div>
        <!-- <RadioGroup v-model="editParams.hyLevel" @on-change='levelChange'>
          <Radio label="0">普通会员</Radio>
          <Radio label="1">初级会员</Radio>
          <Radio label="2">中级会员</Radio>
          <Radio label="3">高级会员</Radio>
          <Radio label="4">SVIP会员</Radio>
        </RadioGroup> -->
      </FormItem>
      <!-- <FormItem class="data-item ivu-form-item-required" label="有效期" prop="checkDate" v-if='editParams.hyLevel !== "0"'>
        <div class="data-col">
          <FormItem prop="startDate">
            <DatePicker v-model="editParams.startDate" type="date" placeholder="开始日期" style="width: 220px"></DatePicker>
          </FormItem>
        </div>
        <span class="line"></span>
        <div class="data-col">
          <FormItem prop="startDate">
            <DatePicker v-model="editParams.endDate" type="date" placeholder="结束日期" style="width: 220px"></DatePicker>
          </FormItem>
        </div>
      </FormItem> -->
       <FormItem label="最大开通子账号数量" prop="maxAccount" class='unit limit-group'>
          <RadioGroup v-model='editParams.maxAccount'>
            <Radio label='limit'>
              <Input type="text" v-model="realMaxAccount" placeholder="请填写开通子账号数量" :disabled='editParams.maxAccount === "noLimit"'/><span class='danwei'>个</span>
            </Radio>
            <Radio label='noLimit'><span class='text'>不限</span></Radio>
          </RadioGroup>
      </FormItem>
      <FormItem label="容量空间" prop="volume" class='unit data-item'>
        <div>
          <Input type="text" v-model="editParams.volume" /><span class='danwei'>G</span>
        </div>
      </FormItem>
      <FormItem label="开启/禁用" prop="companyState" class='data-item data-item-radio'>
        <i-switch v-model="editParams.companyState" size="large">
          <span slot="open">开启</span>
          <span slot="close">禁用</span>
        </i-switch>
      </FormItem>
      <FormItem label="服务费" prop="feeTuiguang" class='data-item'>
        <table class="data-item-table">
          <tr class="data-item-table__tr">
            <th style="width:150px">服务大类</th>
            <th style="width:150px">服务子类</th>
            <th style="width:150px">手续费</th>
          </tr>
          <tr>
            <td>服务费</td>
            <td>推广服务</td>
            <td>
              <Input
                :maxlength="10"
                :title="editParams.feeTuiguang"
                v-model.trim="editParams.feeTuiguang"
                class="data-item-table__input"
                type="text"
                :number="true"
                placeholder="请输入"
                @on-change="changeFuwWuFei"
                @on-blur="blurFuwWuFei"
              />%</td>
          </tr>
        </table>
      </FormItem>
      <FormItem label="直播子域链接" class='unit data-item data-iten-live'>
        <div>
          <Input type="text" v-model="editParams.liveUrl" class="data-item-live_input" placeholder="请填写直播子域链接" />
        </div>
      </FormItem>
      <FormItem label="直播子域账号" prop="liveName" class='unit data-item data-iten-live'>
        <div>
          <Input type="text" v-model="editParams.liveLoginName" class="data-item-live_input" @on-keyup="changeLiveName" autocomplete="off" placeholder="请填写直播子域账号"></Input>
          <Input type="text" v-show="false" style="width: 0;opacity: 0;"></Input>
        </div>
      </FormItem>
      <FormItem label="直播子域密码" prop="livePassword" class='unit data-item data-iten-live'>
        <div>
          <Input type="password" :maxlength="12" v-model="editParams.liveLoginPassword" class="data-item-live_input" @on-keyup="changeLivePassword" placeholder="请填写直播子域密码" ></Input>
          <Input type="password" v-show="false" style="width: 0;opacity: 0;"></Input>
        </div>
      </FormItem>
      <FormItem label="来源渠道" class='unit data-item'>
        <div style="font-size: 12px;">
          {{t_agent_info_agent_name}}
        </div>
      </FormItem>
      <FormItem label="推荐人" class='unit data-item data-iten-live'>
        <div>
          <Input type="text" v-model="editParams.cayAgentName" class="data-item-live_input" placeholder="请输入推荐人" />
        </div>
      </FormItem>
      <div>
        <renzheng-table :data="moneySetData" :type="'edit'" @changeValTips="changeValTips"></renzheng-table>
      </div>
    </template>
    <!-- <button type="primary" @click.prevent="handleSubmit()" class="ivu-btn ivu-btn-primary" :disabled="disabledFlag">确认提交</button> -->
    <div class="edit_company_submit">
      <button type="primary" @click.prevent="handleSubmit()" class="ivu-btn ivu-btn-primary" :disabled="disabledFlag">确认提交</button>
    </div>
  </Form>
</template>

<script>
import { dateObjToStr2 } from '@/utils/common'
import { getEditData, submitEditData, memberAccountDefault } from '@/api/userManager'
import renzhengTable from './components/renzhengTable.vue'
export default {
  name: 'editCompany',
  components: {
    renzhengTable
  },
  data() {
    const validateEditPassword = (rule, value, callback) => {
      const reg = /[\u4e00-\u9fa5]/
      if (value !== '' && value.length < 6) {
        callback(new Error('密码最短为6位'))
      } else if (value !== '' && value.length > 20) {
        callback(new Error('密码最长为20位'))
      } else if (reg.test(value)) {
        callback(new Error('请不要使用汉字'))
      } else {
        callback()
      }
    }
    const validateEditResetPassword = (rule, value, callback) => {
      if (value !== this.editParams.password) {
        callback(new Error('密码输入不一致'))
      } else {
        callback()
      }
    }
    const validateStartDate = (rule, value, callback) => {
      this.$refs['companyInfo'].validateField('checkDate')
      callback()
    }
    const validateCheckDate = (rule, value, callback) => {
      if (!this.editParams.startDate) {
        callback(new Error('开始时间不能为空'))
      } else if (!this.editParams.endDate) {
        callback(new Error('结束时间不能为空'))
      } else if (this.editParams.startDate.getTime() === this.editParams.endDate.getTime()) {
        callback(new Error('时间不能有重合'))
      } else if (this.editParams.startDate > this.editParams.endDate) {
        callback(new Error('结束时间不能早于开始时间'))
      } else {
        callback()
      }
    }
    const validateCheckAccount = (rule, value, callback) => {
      const reg = /^([1-9]\d*|[0]{1,1})$/
      if (!value) {
        callback(new Error('请输入子账号数量'))
      }
      if (value === 'limit') {
        if (!reg.test(this.realMaxAccount)) {
          callback(new Error('请输入正确的子账号数量'))
        }
      }
      callback()
    }
    const validateCheckVolume = (rule, value, callback) => {
      const reg = /^([0-9]+.?[0-9]*|(0|\+?[1-9][0-9]*)|[1-9]\d*)$/
      if (!value) {
        callback(new Error('请输入子容量空间'))
      }
      if (!reg.test(value)) {
        callback(new Error('请输入正确的数字'))
      }
      callback()
    }
    const validateFeeTuiguang = (rule, value, callback) => {
      const reg = /^([0-9]+.?[0-9]*|(0|\+?[1-9][0-9]*)|[1-9]\d*)$/
      value = String(value).replace(/\s+/g, '')
      if (value === '') {
        callback(new Error('请输入服务费'))
      }
      if (value >= 100) {
        callback(new Error('服务费须小于100%'))
      }
      if (!reg.test(value)) {
        // this.editParams.feeTuiguang = String(this.editParams.feeTuiguang)
        callback(new Error('请输入正确的数字'))
      }
      callback()
    }
    // 直播子域账号
    const validateCheckName = (rule, value, callback) => {
      const liveName = this.editParams.liveLoginPassword.replace(/\s+/g, '')
      if (liveName && !this.editParams.liveLoginName) {
        callback(new Error('请输入直播子域账号'))
      }
      callback()
    }
    // 直播子域密码
    const validateCheckPassword = (rule, value, callback) => {
      const liveName = this.editParams.liveLoginName.replace(/\s+/g, '')
      if (liveName && !this.editParams.liveLoginPassword) {
        callback(new Error('请输入直播子域密码'))
      }
      callback()
    }
    // http链接验证
    // const validateCheckLiveUrl = (rule, value, callback) => {
    //   value = String(value).replace(/\s+/g, '')
    //   const reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
    //   if (!reg.test(value)) {
    //     callback(new Error('请输入完整的网址'))
    //   }
    //   this.editParams.liveUrl = value
    //   callback()
    // }
    return {
      corpTypeKey: '', // 1 工业 2 服务商
      editPassword: false, // 编辑的时候是否修改密码
      loading: false,
      volumeObj: {},
      t_agent_info_agent_name: '', // 推荐渠道
      editParams: {
        custNo: '',
        companyId: '', // 企业编码
        companyName: '', // 企业名称
        companyType: '', // 企业类型
        companyDomain: '', // 企业域
        sellerName: '', // 管理员账号
        type: '', // 类型 1 使用 2 正式
        startDate: '', // 开始时间
        endDate: '', // 结束时间
        companyState: '', // 企业状态 0 关闭 1 开启
        password: '',
        resetPassword: '',
        hyLevel: '', // 会员等级
        is_test: '', // 1是 0否 是否测试账号
        maxAccount: '', // 最大开通子账号数量 9999代表不限
        volume: '', // 空间容量 M 1000换算
        liveUrl: '', // 直播url
        liveLoginName: '',
        liveLoginPassword: '',
        feeTuiguang: 0.00, // 服务费
        // 修改基础费用需求-新增
        cayAgentName: '' // 服务商
      },
      vipType: [],
      realMaxAccount: '',
      endDate: '', // 备份endData
      editRules: {
        password: [
          // { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validateEditPassword, trigger: 'blur' }
        ],
        resetPassword: [
          // { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: validateEditResetPassword, trigger: 'blur' }
        ],
        type: [
          { required: true, message: '', trigger: 'change', type: 'number' }
        ],
        startDate: [
          { validator: validateStartDate, trigger: 'change' }
        ],
        checkDate: [
          { validator: validateCheckDate }
        ],
        companyState: [
          { required: true, message: ' ', trigger: 'change', type: 'boolean' }
        ],
        feeTuiguang: [
          { required: true, validator: validateFeeTuiguang, trigger: 'change' }
        ],
        hyLevel: [
          { required: true, message: '请选择会员类型', trigger: 'change' }
        ],
        is_test: [
          { required: true, message: '请选择是否测试账号', trigger: 'change' }
        ],
        maxAccount: [
          { required: true, validator: validateCheckAccount, trigger: 'change' }
        ],
        volume: [
          { required: true, validator: validateCheckVolume, trigger: 'blur' }
        ],
        liveName: [
          { required: false, validator: validateCheckName, trigger: 'blur' }
        ],
        livePassword: [
          { required: false, validator: validateCheckPassword, trigger: 'blur' }
        ]
        // liveUrl: [
        //   { required: false, validator: validateCheckLiveUrl, trigger: 'blur' }
        // ]
      },
      disabledFlag: false, // 提交的点击状态
      moneySetData: [] // 优惠价格数据集合
    }
  },
  created() {
    const pageObj = { title: '编辑', type: 'small', url: '' }
    this.$route.name.indexOf('Industry') !== -1 ? pageObj.url = 'industryList' : pageObj.url = 'serverList'
    this.$store.dispatch('setPage', pageObj)
    this.corpTypeKey = this.$route.name.indexOf('Industry') !== -1 ? 1 : 2
    this.getData({
      company_id: this.$route.params.id,
      corp_type_key: this.corpTypeKey
    })
    this.getColumeObj()
  },
  methods: {
    changeFuwWuFei() {
      // this.editParams.feeTuiguang = String(this.editParams.feeTuiguang).replace(/[^\0-9\.]/g, '')
    },
    blurFuwWuFei() {
      this.editParams.feeTuiguang = String(this.editParams.feeTuiguang).replace(/\s+/g, '')
      // this.editParams.feeTuiguang = isNaN(Number(this.editParams.feeTuiguang).toFixed(2)) ? this.editParams.feeTuiguang : Number(this.editParams.feeTuiguang).toFixed(2)
      this.editParams.feeTuiguang = isNaN(Number(this.editParams.feeTuiguang).toFixed(2)) ? '' : Number(this.editParams.feeTuiguang).toFixed(2)
    },
    getData(params) {
      this.disabledFlag = true
      this.loading = true
      getEditData(params).then(res => {
        this.loading = false
        this.disabledFlag = false
        const { code, result } = res
        if (code === 0) {
          this.t_agent_info_agent_name = result.t_agent_info_agent_name // 渠道
          this.editParams.custNo = result.cust_no // 公司编码
          this.editParams.cayAgentName = result.cay_agent_name // 代理商
          this.editParams.companyId = result.company_id // 公司id
          this.editParams.companyName = result.company_name // 公司名称
          if (!isNaN(result.company_type)) {
            const arr = ['商业公司', '服务商', '药品生产企业']
            this.editParams.companyType = arr[result.company_type]
          } else {
            this.editParams.companyType = result.company_type
          }
          this.editParams.companyDomain = result.company_domain
          this.editParams.sellerName = result.seller_name
          this.editParams.type = result.type * 1
          this.editParams.startDate = new Date(result.start_date + ' 00:00:00')
          this.editParams.endDate = new Date(result.end_date + ' 00:00:00')
          this.endDate = new Date(result.end_date + ' 00:00:00')
          this.editParams.companyState = result.company_state === '1' ? true : false // eslint-disable-line
          this.editParams.feeTuiguang = Number(result.fee_tuiguang).toFixed(2) || 0.00
          this.editParams.hyLevel = result.hy_level
          this.editParams.is_test = result.is_test
          this.editParams.maxAccount = result.max_account * 1 === 9999 ? 'noLimit' : 'limit'
          this.realMaxAccount = result.max_account * 1 === 9999 ? '' : result.max_account * 1
          this.editParams.volume = Number(result.volume) / 1000
          this.editParams.liveUrl = result.live_site_url
          this.editParams.liveLoginName = result.live_login_name
          this.editParams.liveLoginPassword = result.live_login_password
          this.vipType = result.hy_cust_relation.map(item => {
            const vipMap = ['免费', '初级', '中级', '高级']
            item.vipText = vipMap[item.yjh_hy_level] + '会员'
            if (Number(item.yjh_hy_level) === 0) {
              item.vipTime = '永久'
            } else {
              item.vipTime = item.hy_start_date + '至' + item.hy_end_date
            }
            return item
          })
          this.setInitData(result) // 设置优惠价格
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
        }
      })
    },
    // 设置优惠价格
    setInitData(result) {
      this.moneySetData = [
        { // 会员费用
          label: '会员费用',
          labelWidth: 160,
          col: [
            { field: 'type', title: '会员类型', width: 220, titleAlign: 'left', columnAlign: 'left' },
            { field: 'sectionMoney', title: '标准费用', width: 130, titleAlign: 'left', columnAlign: 'left' },
            { field: 'money', title: '优惠后费用', width: 178, titleAlign: 'left', columnAlign: 'left' }
          ],
          data: [
            { type: '初级会员', min: 5000, max: 20000, money: '', val: '', showTips: false },
            { type: '中级会员', min: 20000, max: 50000, money: '', val: '', showTips: false },
            { type: '高级会员', min: 50000, max: 100000, money: '', val: '', showTips: false }
          ]
        },
        { // 流量费用
          label: '流量费用',
          labelWidth: 160,
          col: [
            { field: 'type', title: '流量类型', width: 220, titleAlign: 'left' },
            { field: 'sectionMoney', title: '标准费用', width: 130, titleAlign: 'left' },
            { field: 'money', title: '优惠后费用', width: 178, titleAlign: 'left' }
          ],
          data: [
            { type: '调研次数', min: 500, max: 2000, money: '', val: '', showTips: false },
            { type: '基础报告', min: 400, max: 2000, money: '', val: '', showTips: false },
            { type: '直播场次', min: 100, max: 500, money: '', val: '', showTips: false }
          ]
        }
      ]
      // 设置会员费用数据
      const vipDataMoney = result.hy_list_std.map(item => {
        return item.hy_level_money
      })
      let vipDataVal = []
      if (result.hy_list_sale && result.hy_list_sale.length !== 0) {
        vipDataVal = result.hy_list_sale.map(item => {
          return item.hy_level_money_coupon
        })
      }
      this.moneySetData[0].data.map((item, index) => {
        item.money = vipDataMoney[index]
        item.val = vipDataVal[index] || vipDataMoney[index] || ''
      })
      // end
      // 设置流量费用数据
      const flowDataMoney = [result.coupon_money_std.money_config_report, result.coupon_money_std.money_config_base_report, result.coupon_money_std.money_config_live]
      let flowDataVal = []
      if (result.coupon_money_sale) {
        flowDataVal = [result.coupon_money_sale.money_config_report_coupon, result.coupon_money_sale.money_config_base_report_coupon, result.coupon_money_sale.money_config_live_coupon]
      }
      this.moneySetData[1].data.map((item, index) => {
        item.money = flowDataMoney[index]
        item.val = flowDataVal[index] || flowDataMoney[index] || ''
      })
      // end
    },
    // 显示/隐藏tips提示
    changeValTips(index, indexChildren, type) {
      this.moneySetData[index].data[indexChildren].showTips = type
    },
    // 确认提交-请求参数验证、赋值
    handleSubmit() {
      this.$refs.companyInfo.validate((valid) => {
        if (valid) {
          let params = {
            company_id: this.editParams.companyId,
            corp_type_key: this.corpTypeKey,
            type: this.editParams.type,
            user_time_start: dateObjToStr2(this.editParams.startDate),
            user_time_end: dateObjToStr2(this.editParams.endDate),
            company_state: this.editParams.companyState === true ? 1 : 0, // eslint-disable-line
            password: this.editPassword ? this.editParams.password : '',
            repeat_password: this.editPassword ? this.editParams.resetPassword : '',
            hy_level: this.editParams.hyLevel,
            is_test: this.editParams.is_test,
            max_account: this.editParams.maxAccount === 'limit' ? this.realMaxAccount : '9999',
            fee_tuiguang: this.editParams.feeTuiguang,
            volume: this.editParams.volume * 1000,
            live_site_url: this.editParams.liveUrl,
            live_login_name: this.editParams.liveLoginName,
            live_login_password: this.editParams.liveLoginPassword,
            cay_agent_name: this.editParams.cayAgentName, // 代理商
            cust_no: this.editParams.custNo // 公司编码，取cay_no
          }
          const paramsData = this.moneySetData
          // if (!this.editParams.cayAgentName) {
          //   this.$Message.info('代理商不能为空')
          //   return
          // }
          paramsData[0].data.map(item => {
            if (item.val === '' || item.val < item.min || item.val > item.max) {
              item.showTips = true
            }
          })
          paramsData[1].data.map(item => {
            if (item.val === '' || item.val < item.min || item.val > item.max) {
              item.showTips = true
            }
          })
          // 判断填写的价格区间是否正确
          const vipCloseTips = paramsData[0].data.some(item => item.showTips)
          const flowCloseTips = paramsData[1].data.some(item => item.showTips)
          if (vipCloseTips || flowCloseTips) {
            this.$Message.info('请填写正确的价格')
            return
          }
          // 设置优惠价格
          const examineData = {
            hy_level1_price_sale: paramsData[0].data[0].val, // 初级会员优惠后的价格
            hy_level2_price_sale: paramsData[0].data[1].val, // 中级会员优惠后的价格
            hy_level3_price_sale: paramsData[0].data[2].val, // 高级会员优惠后的价格
            diaoyan_price_sale: paramsData[1].data[0].val, // 调研优惠游的价格
            report_price_sale: paramsData[1].data[1].val, // 报告优惠后的价格
            live_price_sale: paramsData[1].data[2].val // 直播优惠后的价格
          }
          params = { ...params, ...examineData }
          this.editData(params)
        } else {
          return false
        }
      })
    },
    // 确认提交
    editData(params) {
      this.disabledFlag = true
      submitEditData(params).then(res => {
        const { code } = res
        this.disabledFlag = false
        if (code === 0) {
          this.$router.push({ name: this.corpTypeKey === 1 ? 'industryList' : 'serverList' })
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
        }
      })
    },
    resetPassword() { // 点击重置密码的操作
      this.editPassword = true
      this.editParams.password = ''
      this.editParams.resetPassword = ''
    },
    getColumeObj() {
      memberAccountDefault({
        level: -1
      }).then(res => {
        if (res.code === 0) {
          this.columeObj = res.result
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
        }
      })
    },
    levelChange() {
      this.columeObj.forEach(item => {
        if (item.hy_level === this.editParams.hyLevel * 1) {
          this.editParams.maxAccount = item.max_account === 9999 ? 'noLimit' : 'limit'
          this.realMaxAccount = item.max_account === 9999 ? '' : item.max_account
          this.editParams.volume = item.volume / 1000
        }
      })
      if (this.editParams.hyLevel === '0') { // 初级会员
        this.editParams.endDate = new Date('2099-12-31 00:00:00')
      } else {
        this.editParams.endDate = this.endDate // 备份的endDate
      }
    },
    changeLiveName() {
      const name = this.editParams.liveLoginName.replace(/\s+/g, '')
      if (name.length === 0) {
        this.editParams.liveLoginName = ''
      } else {
        this.editParams.liveLoginName = name
      }
    },
    changeLivePassword() {
      const password = this.editParams.liveLoginPassword.replace(/\s+/g, '')
      if (password.length === 0) {
        this.editParams.liveLoginPassword = ''
      } else {
        this.editParams.liveLoginPassword = password
      }
    }
  }
}
</script>

<style lang="scss">
  @import "@/styles/color.scss";
  .edit-company {
    .ivu-form-item {
      .ivu-input {
        border-radius: 2px;
        width: 220px;
      }
      .danwei {
        font-size: 12px;
        position: absolute;
        left: 226px;
      }
    }
    .limit-group.ivu-form-item {
      line-height: 32px;
      .ivu-form-item-label,
      .ivu-form-item-error-tip,
      .ivu-radio,
      .ivu-radio + span {
        line-height: 32px;
        padding-top: 0;
        padding-bottom: 0;
      }
      .danwei {
        top: 9px;
      }
      .ivu-input-wrapper {
        input {
          width: 200px;
          position: relative;
        }
      }
      .ivu-radio-wrapper {
        &:nth-child(2) {
          margin-left: 20px;
        }
      }
    }
    .ivu-form-item-label {
      line-height: 22px;
    }
    .hy-level {
      .ivu-form-item-content {
        top: 0px;
        .ivu-radio-group {
          transform: translateY(10px);
        }
        .ivu-form-item-error-tip {
          left: 463px;
          white-space: nowrap;
        }
      }
    }
    .data-item {
      .ivu-form-item-content {
        &:nth-child(1) {
          top: 2px;
        }
        .ivu-form-item-error-tip {
          left: 462px;
          top: 0px;
          position: absolute;
          white-space: nowrap;
        }
      }
      // .data-item-live .ivu-form-item-content .ivu-form-item-error-tip {
      //   left: 315px !important;
      // }
      .data-item-live_input {
        .ivu-input {
          width: 305px !important;
        }
      }
    }
    .unit {
      .ivu-form-item-content {
        .ivu-form-item-error-tip {
          left: 240px;
          white-space: nowrap;
        }
      }
    }
    .limit-group {
      .ivu-form-item-content {
        .ivu-form-item-error-tip {
          left: 0px;
          white-space: nowrap;
        }
      }
    }
    .data-iten-live {
      .ivu-form-item-content {
        .ivu-form-item-error-tip {
          left: 315px;
          white-space: nowrap;
        }
      }
    }
  }
  .vip-type__item {
    line-height: 14px;
    height: 14px;
    & > * {
      display: inline-block;
      vertical-align: top;
      font-size: 12px;
    }
    & + & {
      margin-top: 12px;
    }
  }
  .vip-type__time {
    margin-left: 10px;
    color: $fontGray;
  }
  .data-item-table {
    font-size: 12px;
    border: solid 1px $tableBorderColor;
    border-collapse:collapse;
    text-align: left;
    &__input {
      width: 80px;
      height: 28px;
      margin-top: 5px;
      margin-right: 5px;
      .ivu-input {
        width: 100% !important;
        height: 28px !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      // line-height: 28px;
      // border: solid 1px $tableBorderColor;
      // border-radius: 4px;
      // padding: 0 5px;
      // color: $fontBlack;
    }
    &__tr {
      background: $tableTrLightColor;
      border-bottom: solid 1px $tableBorderColor;
    }
    & tr {
      height: 38px;
      line-height: 38px;
    }
    & th {
      color: $fontBlack;
      font-weight: 600;
    }
    & th,
    & td {
      padding: 0 10px;
    }
  }
  .data-item-radio {
    & /deep/.ivu-form-item-content,
    & /deep/.ivu-form-item-label {
      line-height: 22px !important
    }
  }
  .edit_company_submit {
    position: fixed;
    left: 0px;
    bottom: 0px;
    width: 100%;
    height: 60px;
    box-shadow: 0 -1px 3px 0px  rgba(144, 164, 183, 0.22);
    background: $white;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    padding-top: 8px;
    padding-right: calc(50% - 394px);
    z-index: 99;
  }
</style>
